module.exports = __webpack_public_path__ + "img/d90b7cc65e38dc8c229f5ca621fed927.jpg";